import { SpreadsheetRecordData } from "../project-stakeholder-list/ProjectStakeholderListState";

export type InputStakeholderDialogState = {
  isShow: boolean;
  saved: SpreadsheetRecordData;
  edited: SpreadsheetRecordData;
  codes: {
    searchTypeList: Option[];
    roleCdList?: Option[];
    teamCdList?: Option[];
  };
  fieldPath: FieldPath;
  displayFilter: String;
  fromActionList: boolean;
  requireRow: boolean;
  rowIdx: number;
  status: {
    searchType: string;
    searchStr: string;
    isUpdated: boolean;
    invalidList: string[];
    notFound: boolean;
  };
};

export type Option = {
  label: string;
  value: string;
  cvrgType?: string;
};

export type FieldPath = {
  searchStr: string;
  teamCd: string;
  roleCd: string;
};

export type PageNewState =
  | InputStakeholderDialogState
  | ((prevState: InputStakeholderDialogState) => InputStakeholderDialogState);
